<template>
    <div>
        <div class="main-content">
            <div class="heading-con">
              <span  class="heading-bold">Payroll Billing Period: </span>
              <span style="color: #4d4d4d65;">Start: 03/01/24 | End: 03/16/25</span>
            </div>

            <div class="table-con">
            <table border="1">
              <thead>
                  <tr>
                      <th>
                        <div class="profiles">
                          <span></span>
                        </div>
                      </th>
                      <th>Instructor</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Billable Hours</th>
                      <th>Un-Billable Hours</th>
                      <th>Grade</th>
                      <th>Link</th>
                      <th>Notes</th>
                      <th>Approve</th>
                      <th>Pay</th>
                  </tr>
              </thead>
              <tbody>
                  <tr v-for="(task, index) in nonBill" :key="index">
                    <td class="prof"><img :src="task.Prof" alt="img"></td>
                    <td>{{ task.Inst }}</td>
                    <td>{{ task.Sdate }}</td>
                    <td>{{ task.Edate }}</td>
                    <td>{{ task.Bill }}</td>
                    <td>{{ task.UnBill }}</td>
                    <td class="green-td">{{ task.Grade }}%</td>
                    <td><img :src="task.Link" alt="img"></td>
                    <td><img :src="task.Notes" alt="Notes"></td>
                    <td class="green-td">{{ task.Appr }}</td>
                    <td>
                      <div class="display-con">
                         <div class="submission-display green">
                           <span>Payroll</span>
                           <h2>$2,500</h2>
                         </div>
                       </div>
                    </td>
                  </tr>
                  <tr>
                      <td colspan="3"></td>
                      <td>Total</td>
                      <td>+ 5 hrs 50 min 0 sec</td>
                      <td class="green-td">Approved</td>
                  </tr>
              </tbody>
          </table>

          </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "PayrollBillingPeriod",
// }
// export default {
//   name: "InstructorPayroll",
  // components: {

  // },
  data() {
    return {
      nonBill: Array.from({ length: 10 }, () => ({ 
        Prof: '/static/img/top-gun-tom-cruise.png',
        Inst: 'Mathew Benesik',
        Sdate: '01/23/24',
        Edate: '01/23/24',
        Bill: '+ 5h 50min 0sec',
        UnBill: '+ 5h 50min 0sec',
        Grade: '97',
        Link: '/static/img/LinkIcon.svg',
        Notes: '/static/img/notes.svg',
        Appr: 'Sign',
        Pay: '$2,500',

        // task: "Task 1",
        // assignedBy: "David Lines",
        // dateAssigned: "01/23/24",
        // dateComplete: "01/23/24",
        // time: "+ 50min 0sec",
        // status: "Complete",
        // notesImg: "/static/img/notes.svg",
        // check: "/static/img/check.svg",
        // sign: "Signed"
      })),
    }
  }
}
</script>

<style>
* {
/**setfont size */
  --prof-font-smaller: 12px;
  --prof-font-small: 14px;
  --prof-font-normal: 18px;
  --prof-font-big: 20px;
  --prof-font-large: 60px;
 /**bg */
  --color-grey: #4d4d4d65;
}


.main-content {
  padding: 40px;
  color: #494949;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.main-content div{
  display: flex;
}

.btns div,
.btns button
{
  --comp-bg: #c5c5c5;
  --comp-padding: 4px 40px;
  --comp-width: auto;
  --comp-color: #4c4c4c;

  margin-top: 5px;
  background-color: var(--comp-bg);
  padding: var(--comp-padding);
  width: var(--comp-width);
  border-radius: 5px;
  color: var(--comp-color);
  font-size: calc(var(--prof-font-normal ) - 5px);
  justify-content: center;
  font-weight: normal;
  height: fit-content;
}
/* Override for specific buttons */
.btns .blue {
    --comp-bg: #3C78FF;
    --comp-width: 100%;
    --comp-color: #ffffff;
}

.btns .red {
    --comp-bg: #FF0000;
    --comp-width: 100%;
    --comp-color: #ffffff;
}

.btns .green {
    --comp-bg: green;
    --comp-width: 100%;
}

.btns .grey {
    --comp-bg: rgb(207, 207, 207);
    --comp-width: 100%;
}

.btns .blue {
    --comp-bg:#3171E2;
    --comp-width: fit-content;
}

.heading-con {
  align-items: center;
}

.heading-bold{
  margin-right: 10px; 
  font-size: calc(var(--prof-font-big) + 5px);
  font-weight: 700;
}

/* ====================TABLE==================== */

.table-sec {
  flex-direction: column;
  gap: 10px !important;
}

.table-con {
  border-radius: 16px;
  overflow: hidden;
  width: 100%;
  box-shadow: 0 0px 8px #00000050;
}

table {
  border-collapse: collapse;
  width: 100%;
}

thead {
  background-color: #3C78FF;
  color: white;
  
}

th, td {
  border: 1px solid #8c8c8cbe; 
  padding: 8px 10px;
  font-size: calc(var(--prof-font-normal ) - 5px);
  text-align: center;
  width: fit-content;
}

th {
  padding: 7px 10px;
  font-weight: normal;
  border: 1px solid #c7c7c7be; 
  border-top: 1px solid #3C78FF;
  text-align: center !important;
}

.profiles span{
  display: flex;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #ffffff7c;
  align-items: center;
  justify-content: center;
}

.profiles {
  width: 100%;
  justify-content: center;
}



/* ====================TABLE CONTENT==================== */

.green-td {
  color: #00A551 !important;
}

.green-td img{
  filter: invert(51%) sepia(94%) saturate(583%) hue-rotate(108deg) brightness(92%) contrast(95%);
  margin-left: 10px;
}

.prof img {
  width: 40px;
  height: 40px;
  border-radius: 10%;
  cursor:auto;
  padding: 0;
}

td img {
  cursor: pointer;
  padding: 9px;
}

/* ====================DISPLAY PAY==================== */

.display-con {
  display: flex;
  width: 100%;
  justify-content: center;
}

.submission-display {
  --set-bgcolor: var(--color-grey);
  --set-color: #484848;

  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: fit-content;
  width: 160px;
  gap: 0px;
  border-radius: 10px;
  box-shadow: 0 4px 8px #19191918;
  background-color: var(--set-bgcolor);
  color: var(--set-color);
}

.submission-display h2{
  margin: 2px;
}

.submission-display.green{
  --set-bgcolor: #00A551 ;
  --set-color: white;
}

.submission-display h2{
  font-weight: 600;
  font-size: 23px;
  color: var(--set-color);
}

.submission-display span{
  color: var(--set-color);
}
</style>

